import {
	Icon,
	Box,
	HStack,
	VStack,
	Text,
	Image,
	Button,
	Switch,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	ModalCloseButton,
	CloseButton,
	Flex,
} from '@chakra-ui/react'
import SVGIcon from '../../assets/svgIcons'
import { useLanguageContext } from './../../context/locale.context'

const EditQrCodeDetails = ({ details, setDetails, isOpen, onClose }) => {
	const {
		state: { locale },
	} = useLanguageContext()

	console.log('details', details)

	return (
		<Box
			display={isOpen ? 'flex' : 'none'}
			alignItems='center'
			w='100%'
			h='100%'
			backgroundColor='rgba(0,0,0,0.4)'
			position='absolute'
			backdropFilter='blur(1px)'
			zIndex='1'
		>
			<Flex
				// zIndex='1'
				background='#FFF'
				borderRadius='15px'
				w='80%'
				ml='auto'
				mr='auto'
				h='90%'
				flexDirection='column'
				justifyContent='space-between'
			>
				<Flex mt='25px' pl='2rem' pr='1.25rem' alignItems='center'>
					<Text fontWeight='500' letterSpacing='0.2px' fontSize='1rem'>
						{locale['Share Business card']}
					</Text>
					<CloseButton
						ml='auto'
						color='red.600'
						_hover={{ background: 'white' }}
						onClick={onClose}
					/>
				</Flex>

				<Box overflowY='auto' w='100%'>
					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' color='#828282' fontSize='15px' fontWeight='500'>
							{locale['Name']} ({locale['Mandatory']})
						</Box>
						<Box mr='25px' position='relative'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked
							/>
							<Box mt='-17px' ml='19px' position='absolute'>
								<SVGIcon
									iconName='LockSvg'
									svgProps={{
										width: '10',
										height: '12',
										viewBox: '0 0 10 12',
									}}
									pathProps={{ fill: '#009B76' }}
								/>
							</Box>
						</Box>
					</Box>

					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' color='#828282' fontSize='15px' fontWeight='500'>
							{locale['Company']}
						</Box>
						<Box mr='25px' position='relative'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked
							/>
							<Box mt='-17px' ml='19px' position='absolute'>
								<SVGIcon
									iconName='LockSvg'
									svgProps={{
										width: '10',
										height: '12',
										viewBox: '0 0 10 12',
									}}
									pathProps={{ fill: '#009B76' }}
								/>
							</Box>
						</Box>
					</Box>

					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' fontSize='15px' fontWeight='500'>
							{locale['Designation']}
						</Box>
						<Box mr='25px'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked={details['designation'] ? 'true' : ''}
								onChange={() =>
									setDetails(prevState => ({
										...prevState,
										designation: !prevState['designation'],
									}))
								}
							/>
						</Box>
					</Box>

					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' fontSize='15px' fontWeight='500'>
							{locale['Primary Phone Number']}
						</Box>
						<Box mr='25px'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked={details['phoneNumber'] ? 'true' : ''}
								onChange={() =>
									setDetails(prevState => ({
										...prevState,
										phoneNumber: !prevState['phoneNumber'],
									}))
								}
							/>
						</Box>
					</Box>
					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' fontSize='15px' fontWeight='500'>
							{locale['Alternate Phone Number']}
						</Box>
						<Box mr='25px'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked={details['altPhoneNumber'] ? 'true' : ''}
								onChange={() =>
									setDetails(prevState => ({
										...prevState,
										altPhoneNumber: !prevState['altPhoneNumber'],
									}))
								}
							/>
						</Box>
					</Box>
					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' fontSize='15px' fontWeight='500'>
							{locale['Primary email address']}
						</Box>
						<Box mr='25px'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked={details['email'] ? 'true' : ''}
								onChange={() =>
									setDetails(prevState => ({
										...prevState,
										email: !prevState['email'],
									}))
								}
							/>
						</Box>
					</Box>
					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' fontSize='15px' fontWeight='500'>
							{locale['Alternate email address']}
						</Box>
						<Box mr='25px'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked={details['altEmail'] ? 'true' : ''}
								onChange={() =>
									setDetails(prevState => ({
										...prevState,
										altEmail: !prevState['altEmail'],
									}))
								}
							/>
						</Box>
					</Box>
					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' fontSize='15px' fontWeight='500'>
							{locale['Address']}
						</Box>
						<Box mr='25px'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked={details['address'] ? 'true' : ''}
								onChange={() =>
									setDetails(prevState => ({
										...prevState,
										address: !prevState['address'],
									}))
								}
							/>
						</Box>
					</Box>
					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' fontSize='15px' fontWeight='500'>
							{locale['Date Of Birth']}
						</Box>
						<Box mr='25px'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked={details['dateOfBirth'] ? 'true' : ''}
								onChange={() =>
									setDetails(prevState => ({
										...prevState,
										dateOfBirth: !prevState['dateOfBirth'],
									}))
								}
							/>
						</Box>
					</Box>
					<Box
						display='flex'
						borderBottom='1px solid #e0e0e0'
						alignItems='center'
						justifyContent='space-between'
						h='50px'
					>
						<Box ml='25px' fontSize='15px' fontWeight='500'>
							{locale['Blood Group']}
						</Box>
						<Box mr='25px'>
							<Switch
								sx={{
									'span.chakra-switch__track[data-checked]': {
										backgroundColor: 'brand.700',
									},
								}}
								size='md'
								isChecked={details['bloodGroup'] ? 'true' : ''}
								onChange={() =>
									setDetails(prevState => ({
										...prevState,
										bloodGroup: !prevState['bloodGroup'],
									}))
								}
							/>
						</Box>
					</Box>
				</Box>
				<Flex
					boxShadow='0px 8px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 88px -4px rgba(24, 39, 75, 0.14)'
					px='1.5rem'
					py='0.5rem'
				>
					{/* <Button variant='modalCloseButton' onClick={onClose}>
						{locale['Cancel']}
					</Button> */}
					<Button ml='auto' variant='modalSubmitButton' onClick={onClose}>
						{locale['Continue']}
					</Button>
				</Flex>
			</Flex>
		</Box>
	)
}

export { EditQrCodeDetails }
